<template>
    <div ref="container">
    </div><!--ref:container-->
</template>

<script>
var moment = require('moment');
export default {
    props: [
        'returnpath',
    ],
    data: function(){
        return {
            auth: {
                email: "",
                password: "",
                remember: 0,
            },
            errors: [],
        }
    },
    mounted() {
        logoutUser();
    },
    methods: {
        logoutUser() {
            this.setLoading(true);
            //axios.post('/api/vp1/patients/authenticate', this.auth).then((res) => {
            axios.post('/patient/logout', this.auth).then((res) => {
                this.setLoading(false);
                this.addNotification({type: "success", content: this.$t('translations.logged_out_successfully') });
                window.api_token = null;
                this.$root.api_token = window.api_token;

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                this.$root.loadCore(true, {name: this.$route.params.next});
                console.log(res.data);

            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
            });
        }
    }
}
</script>
